import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";

export default function StatTiles({ data }: any) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
  
    const currentSection = sectionRef.current;
  
    if (currentSection) {
      observer.observe(currentSection);
    }
  
    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  
    //eslint-disable-next-line
  }, []);

  return (
    <section
      ref={sectionRef}
      className="fact__area-three fact__bg newsletter__area mb-20"
      data-background="/assets/img/bg/fact_bg.jpg"
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-9 col-lg-9 col-12 res-card">
            <div className="section__title white-title text-center mb-10">
              <h2 className="title text-black">{data?.title}</h2>
              <p className="text-black">{data?.subTitle}</p>
            </div>
            <div className="fact__item-wrap-two">
              <div className="row justify-content-center">
                {data?.factAreaWrapper?.map((item: any, index: number) => (
                  <div
                    className="col-xl-4 col-lg-4 col-md-6 col-12 res-card"
                    key={index}
                  >
                    <div
                      className="fact__item fact__item-two h-100"
                      style={{ background: "#f6ebfc" }}
                    >
                      <h2
                        className="count"
                        style={{ fontSize: 50, color: "#d2a7e9" }}
                      >
                        {isVisible && (
                          <CountUp
                            start={0}
                            end={parseInt(item?.factAreaCounter)}
                            duration={2.75}
                            separator=","
                          />
                        )}
                      </h2>
                      <p className="text-black">{item?.factAreaTitle}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-xl-3 col-lg-3 col-md-6 res-card">
            <div className="blog-widget blogbgDesign">
              <h4 className="widget-title text-white">Upcoming Events</h4>
              <div className="swiper-container upcoming-event-swiper-active">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="brand__item-two">
                      <img
                        src="/assets/img/index/upcoming-events/1.jpg"
                        alt="img-text"
                        width={270}
                        height={270}
                      />
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand__item-two">
                      <img
                        src="/assets/img/index/upcoming-events/2.jpg"
                        alt="img-text"
                        width={270}
                        height={270}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fact__shape-wrap d-sm-none d-md-none">
        <img
          src="/assets/img/others/h3_fact_shape01.svg"
          alt="shape"
          className="alltuchtopdown"
          width={72}
          height={77}
        />
        <img
          src="/assets/img/others/h3_fact_shape02.svg"
          alt="shape"
          className="rotateme"
          width={69}
          height={69}
        />
      </div>
    </section>
  );
}
